import { render, staticRenderFns } from "./OrderItemsListComponent.vue?vue&type=template&id=30ef25c1&scoped=true&"
import script from "./OrderItemsListComponent.vue?vue&type=script&lang=js&"
export * from "./OrderItemsListComponent.vue?vue&type=script&lang=js&"
import style0 from "./OrderItemsListComponent.vue?vue&type=style&index=0&id=30ef25c1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ef25c1",
  null
  
)

export default component.exports